module.exports = __webpack_public_path__ + "img/logo_wbs.da49e0c0.png";